import emailAddressValidator from './emailAddress';
import telephoneNumberValidator from './telephoneNumber';

export { emailAddressValidator, telephoneNumberValidator };
